const cselectImages = {
  down: './assets/images/ic-down-16.png',
};

export default cselectImages;
